"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siftTypes = void 0;
var siftTypes = {
  flight: 'flight',
  hotel: 'hotel',
  rentalcar: 'rentalcar',
  train: 'train',
  boardingPass: 'boardingpass',
  shipment: 'shipment',
  purchase: 'purchase',
  restaurant: 'restaurant',
  event: 'event',
  bill: 'bill',
  cruise: 'cruise',
  priceAlert: 'pricealert'
};
exports.siftTypes = siftTypes;
//# sourceMappingURL=constants.js.map